<template>
    <div class="performance-box">
        <h1>What Happened to Your Sales Performance in 24 months?</h1>

        <!-- <h3>Final Scores:</h3> -->
        
        <div class="performance-metric-row">
            <div class="performance-metric">
                <div>
                    <h3>This Offering</h3>
                    <p>{{ performance.offering }}</p>
                    <div class="caption">Sales Growth of This Offering (Starting Value is .5%; Best Final Score is .4% A score higher than .4% indicates too much focus on this offering, at the expense of new opportunities).</div>
                </div>
            </div>
            <div class="performance-metric">
                <div>
                    <h3>New Opportunities</h3>
                    <p>{{ performance.opportunities }}</p>
                    <div class="caption">Sales Growth from New Opportunities (Best is 20%).</div>
                </div>
            </div>
        </div>

        <h3>Your scanning approach created a set of data and insights. What would you do with that data and insights as a leader? High scores in scanning breadth and balance would help you to:</h3>
        
        <ul>
            <li>Make strategic decisions about this offering. You may have recognized that this offering is in a normal maturity stage of its product life cycle. While you can extend its life and sales through different strategies, eventually it makes sense to redirect investment from it for new growth areas in the business. </li>
            <li>Find new growth opportunities. Your ability to stay ahead of customer needs is improved by watching the external environment, asking great questions and finding new sources of information. Your scanning approach here may have opened up additional possibilities for new ideas.</li>
        </ul>

        
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"

    export default{
        name : "PerformanceFeedback",
        computed : {
            ...mapGetters([
                "getBreadthResult",
                "getBalanceResult",
                "getScoring"
            ]),
            performance(){
                const balance = this.getBalanceResult
                const breadth = this.getBreadthResult
                return this.getScoring.performance.options[ balance ][ breadth ]
            }
        }
    }
</script>